import * as Sentry from "@sentry/react";

type Source = Partial<Record<string, string | boolean | undefined>>;

/**
 * Sentry sozlamasi. `VITE_SENTRY_DSN` build paytida kodga yoziladi; bo'sh
 * bo'lsa (lokal, testlar) Sentry ishga tushmaydi.
 *
 * Shaxsiy va so'rov ma'lumotlari yig'ilmaydi (SDK standarti hammasini oladi),
 * tracing va replay o'chiq — bepul tarif limiti xatolar uchun qolsin.
 */
export function sentryOptions(source: Source) {
  const raw = source.VITE_SENTRY_DSN;
  const dsn = typeof raw === "string" ? raw.trim() : "";
  if (!dsn) return null;

  const release = typeof source.VITE_SENTRY_RELEASE === "string" ? source.VITE_SENTRY_RELEASE : "";
  return {
    dsn,
    environment: typeof source.MODE === "string" ? source.MODE : "development",
    release: release.trim() || undefined,
    tracesSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
  };
}

/** DSN bo'lsa SDK ni ishga tushiradi. `true` — yoqildi. */
export function initSentry(source: Source, init: typeof Sentry.init = Sentry.init): boolean {
  const options = sentryOptions(source);
  if (!options) return false;
  init(options);
  return true;
}
